import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-red-500 text-white p-4 text-center">
            © 2024 vThink Global Technologies Pvt. Ltd. All Rights Reserved
        </footer>
    );
};

export default Footer;
